import httpClient from './Http'

export default {

	getProUserProfile(id){
		return httpClient.get(`/api/pro/profile/${id}`);
	},

    getPublicProjectsForUser(userId) {
        return httpClient.get(`/api/pro/profile/${userId}/projects`);
    },

    getCollaborationsForUser(userId) {
        return httpClient.get(`/api/pro/profile/${userId}/collaborations`);
    }
}


// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/ProProfileService.js